// import React from "react";
// import SEO from "../components/Seo";

// const Profile = () => {
//   return (
//     <>
//       <SEO
//         title="AICURD – Profile of AICURD"
//         description="Profile of AICURD, leading initiatives in rural development, health, education, and women empowerment since 1985."
//         keywords="AICURD, All India Centre for Urban and Rural Development, NGO Leadership, Rural Development Leader, Social Services, Community Development, NGO Profile, Women Empowerment, Health Awareness, Poverty Alleviation, Social Entrepreneur, SC ST Welfare, Tribal Welfare, Social Services NGO"
//         author="MR PRINCE GUPTA"
//         url="https://aicurd.org/profile"
//         image="https://aicurd.org/images/profile-cover.jpg"
//       />
//       <section className="w-full h-full flex flex-col poppins-regular md:flex-row justify-center items-center bg-gray-100 py-10 gap-6 sm:gap-8 md:gap-10">
//         <div className="w-11/12 flex flex-col justify-center items-center">
//           <h1 className="text-5xl poppins-medium-italic">
//             <strong>ALL INDIA CENTRE FOR URBAN & RURAL DEVELOPMENT</strong>
//           </h1>
//           <div>
//             <div className="w-full max-w-4xl mx-auto p-4">
//               <div className="rounded-2xl shadow-lg border bg-white">
//                 <div className="px-5 py-4 border-b">
//                   <h2 className="text-xl md:text-2xl font-semibold tracking-tight">
//                     Organization Details
//                   </h2>
//                 </div>

//                 <div className="overflow-x-auto">
//                   <table className="w-full border-collapse">
//                     <tbody>
//                       <tr className="border-b">
//                         <th className="w-1/3 text-left p-3">
//                           Year of Establishment
//                         </th>
//                         <td className="p-3">1985</td>
//                       </tr>
//                       <tr className="border-b">
//                         <th className="text-left p-3">
//                           Organization Registration – Type & No.
//                         </th>
//                         <td className="p-3">
//                           Registered under Societies Registration Act of 1860;
//                           Registration No.: S/15843
//                         </td>
//                       </tr>
//                       <tr className="border-b">
//                         <th className="text-left p-3">
//                           Organization PAN Card No.
//                         </th>
//                         <td className="p-3">AAATA3799C</td>
//                       </tr>
//                       <tr className="border-b">
//                         <th className="text-left p-3">
//                           Approval Under Section 80G & 12A
//                         </th>
//                         <td className="p-3">Enclosed</td>
//                       </tr>
//                       <tr className="border-b">
//                         <th className="text-left p-3">
//                           CSR Registration Certificate (MCA)
//                         </th>
//                         <td className="p-3">Enclosed</td>
//                       </tr>
//                       <tr className="border-b">
//                         <th className="text-left p-3">
//                           NGO DARPAN Registration No.
//                         </th>
//                         <td className="p-3">DL/2009/0006449</td>
//                       </tr>
//                       <tr className="border-b">
//                         <th className="text-left p-3">
//                           Organization Contact Address
//                         </th>
//                         <td className="p-3">
//                           16, Bhai Veer Singh Marg, Gole Market, New Delhi
//                           110001
//                         </td>
//                       </tr>
//                       <tr className="border-b">
//                         <th className="text-left p-3">Contact Person</th>
//                         <td className="p-3">
//                           Ms. Janani Ray, General Secretary, AICURD
//                         </td>
//                       </tr>
//                       <tr className="border-b">
//                         <th className="text-left p-3">Email</th>
//                         <td className="p-3">aicurd@yahoo.com</td>
//                       </tr>
//                       <tr>
//                         <th className="text-left p-3">Contact</th>
//                         <td className="p-3">9717524902</td>
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="space-y-6 leading-relaxed">
//             <h2 className="text-2xl font-bold text-center mb-6">
//               ORGANIZATION’S VISION AND MISSION STATEMENTS
//             </h2>

//             <ul className="list-disc pl-6 space-y-4 text-justify">
//               <li>
//                 To undertake innovative and experimental welfare projects in
//                 urban and rural areas with the focus on upliftment of
//                 disadvantaged sections such as Scheduled Castes, Scheduled
//                 Tribes, Other Backward Classes, women and children, aged,
//                 handicapped, infirm, and mentally retarded.
//               </li>

//               <li>
//                 To undertake Khadi and Village Industries’ projects,
//                 establishment of emporia and SanitaryMart, formation of
//                 Cooperative Societies and training to its members, housing and
//                 resettlement activities for economically or otherwise
//                 disadvantaged people in urban and rural areas by way of concept
//                 formulation, survey, planning, supervision, production of
//                 low-cost and innovate building and sanitary materials,
//                 construction, financing, management, research and development
//                 and/or training, Rashtriya MahilaKosh programmes for male and
//                 female, information of Thrift and Credit societies etc.
//               </li>

//               <li>
//                 To raise funds by way of loan, grant, donations, fees etc. For
//                 any person(s) the state or central government organisations,
//                 companies, semi-government organisations, institutions or
//                 otherwise for the purpose of fulfilling the objectives of the
//                 Society and to provide funds to such beneficiaries as may be
//                 identified by the AICURD.
//               </li>

//               <li>
//                 To review the functioning of delivery system for development and
//                 to suggest ways and means of making these more effective so as
//                 to reach the poor urban and rural dwellers.
//               </li>

//               <li>
//                 To collaborate with extension agencies, Panchayat Raj
//                 Institutions, Voluntary Agencies, Industrial and Business
//                 Houses, Central and State Governments, UN and International
//                 agencies for promotion of urban and rural development.
//               </li>

//               <li>
//                 To study, evaluate and evolve strategies and projects of urban
//                 and rural development.
//               </li>
//               <li>
//                 To undertake training and research activities in relation to
//                 urban and rural development.
//               </li>
//               <li>
//                 To undertake consultancy services in urban and rural
//                 development.
//               </li>
//               <li>
//                 To serve an nodal agency for national, international, government
//                 and non-governmental organization in India.
//               </li>
//               <li>
//                 To enter into collaborative/professional activities at the grass
//                 roots, and international levels. To foster and promote sense of
//                 duty, awareness and community participation in relation to urban
//                 and rural development.
//               </li>
//               <li>
//                 To plan, promote, assist, monitor and guide in the
//                 implementation of programmes and activities of social and
//                 economic nature designed for slum sector.
//               </li>
//               <li>
//                 To study, evaluate, evolve and undertake strategies and projects
//                 of free legal aid and advice to weaker section.
//               </li>
//               <li>
//                 To encourage inculcation of sense of pride in the cultural
//                 heritage of India and to work for promotion of national
//                 integration and communal harmony in fulfillment of NIC
//                 objectives.
//               </li>
//               <li>
//                 To seek and accept financial assistance from governmental and
//                 nongovernmental agencies, Trusts, Foundations, Business Houses,
//                 International Agencies and such other organizations.
//               </li>
//               <li>
//                 To develop laboratory facilities for preparation of audio-visual
//                 aids.
//               </li>
//               <li>
//                 Since inception in the year 1985, AICURD has implemented large
//                 number of projects on Health,Education, Environment, Women
//                 Empowerment, Socio–Economic Survey, Capacity building and Skill
//                 formation, Poverty Alleviation and Generating Awareness on
//                 Social issues to improve the quality of life. Some of them are
//                 :-
//               </li>
//             </ul>
//             <h2 className="text-2xl font-semibold">Socio-Economic Survey</h2>
//             <p>
//               None can ignore the genuine desireof the Government to uplift the
//               SC/ST people and the role played by its efforts in changing the
//               mode of thinking and attitudes of these two segments of the
//               population. Thus, the educational policies of the Government,
//               provision of reservation in jobs, policies in the fields of
//               agriculture, cooperation, communication, industrialization, social
//               services, etc. have brought the members of the Scheduled Caste and
//               Scheduled Tribe communities closer to the main stream of national
//               life. Tribal markets have been linked up with urban markets
//               providing greater economic opportunities to the tribals and SCs
//               creating a commercial attitude in them, as a result, the concept
//               of saving is gaining acceptance, and there is a definite shift in
//               the consumption pattern of these two communities from need based
//               to consumer durable goods. Yet, all said and done, the efforts so
//               far have not helped in solving, in any significant measure, the
//               problems of poverty, malnutrition and exploitation faced by the
//               tribal as well as the Scheduled Castes.
//             </p>
//             <p>
//               Keeping all these considerations in view, the Government of India
//               initiated special schemes for the development of the areas
//               inhabited by these two communities to supplement the benefits
//               accruing from general programmes of development in different
//               fields. These can be grouped broadly under four heads (a)
//               communication s (b) education and culture (c) development of
//               tribal economy and (d) health, housing and water supply.
//             </p>
//             <p>
//               AICURD was awarded the task of conducting mid-term survey to
//               assess the impact of those schemes on these two communities in
//               relation to the following four districts spreading over three
//               states, being sponsored by the Union Ministry of Welfare.
//             </p>
//             <ul className="list-disc pl-6 space-y-4 text-justify">
//               <li>
//                 <strong className="text-orange-500">
//                   Socio-Economic Survey Project for the Upliftment of Schedule
//                   Castes and Scheduled Tribes, Nizamabad District, Andhra
//                   Pradesh
//                 </strong>
//                 <p>
//                   On our proposal for the implementation of the Socio economic
//                   survey project for upliftment of Scheduled Castes and
//                   Scheduled Tribes in the District of Nizamabad in Andhra
//                   Pradesh, the Minister of Welfare, Government of India
//                   sanctioned grant-in-aid in December, 1990. The survey work was
//                   delayed due to initial problems as a sequel to Naxalite menace
//                   in the area. However, with the concerted efforts of the
//                   dedicated, diligent social workers to whom the responsibility
//                   was assigned, the survey could be conducted and the final
//                   report was then completed and submitted to the Ministry of
//                   Welfare
//                 </p>
//               </li>
//               <li>
//                 <strong className="text-orange-500">
//                   Socio-Economic Survey Project for the Upliftment of Scheduled
//                   Castesand Scheduled Tribes, District, Mahboob Nagar, Andhra
//                   Pradesh
//                 </strong>
//                 <p>
//                   The Ministry of Welfare, Government of India, New Delhi,
//                   sponsored the Socio-Economic Survey Project for the upliftment
//                   of the Scheduled Castes and Scheduled Tribes in the District
//                   of Mahboob Nagar in Andhra Pradesh. A Comprehensive Report had
//                   been prepared and the same was submitted to the Ministry of
//                   Welfare.
//                 </p>
//               </li>
//               <li>
//                 <strong className="text-orange-500">
//                   Socio-Economic Survey Project for the Upliftment of Scheduled
//                   Castesand Scheduled Tribes, District Dumka, Bihar
//                 </strong>
//                 <p>
//                   We had taken up the survey project in respect of the Scheduled
//                   Castes and Scheduled Tribes in Dumka, Bihar, with the
//                   financial assistance granted by the Ministry of Welfare, Govt.
//                   of India. The survey work was conducted and the final report
//                   being duly scrutinized, was submitted to the Ministry of
//                   Welfare in time.
//                 </p>
//               </li>
//               <li>
//                 <strong className="text-orange-500">
//                   Socio-Economic Survey Project for the Upliftment of Scheduled
//                   Castesand Scheduled Tribes, District Jalpaiguri, West Bengal
//                 </strong>
//                 <p>
//                   The JalpaiguriDistrict of North Bengal is mainly inhabited by
//                   the Scheduled Castes and Scheduled Tribes. With the financial
//                   assistance granted by the Ministry of Welfare, Govt. of India,
//                   the survey was successfully conducted and the report was
//                   submitted to the concerned Ministry within the stipulated
//                   time.
//                 </p>
//               </li>
//               <li>
//                 <strong className="text-orange-500">
//                   Socio-Economic Survey Project for the Upliftment of Scheduled
//                   Castesand Scheduled Tribes, District Purulia, West Bengal
//                 </strong>
//                 <p>
//                   The Purulia District, West Bengal, is one of the backward ones
//                   in the State, with a high concentration of SC/STs population.
//                   A mid-term survey survey was conducted with the financial
//                   assistance of the Ministry of Welfare, Govt. of India to
//                   access the status of upliftment of these categories, that was
//                   accomplished successfully and submitted to the concerned
//                   Ministry within the stipulated period.
//                 </p>
//                 <p>
//                   In the area of health and Reproductive Child Health (RCH),
//                   AICURD has organized awareness camps focusing on subjects like
//                   Malaria and RCH. AICURD has also conducted programs on
//                   Targeted Intervention (TI) for Migrant Workers in Slums in
//                   Delhi to control and prevent HIV/AIDS, together with
//                   Generation of Scientific Awareness among Children &
//                   Adolescents in the Schools of Delhi, and on TB control
//                   Programme in and around the city of Delhi
//                 </p>
//               </li>
//             </ul>
//             <h3>
//               <strong className="text-gray-800 text-xl">
//                 Targeted Intervention for Prevention of HIV/AIDS
//               </strong>
//             </h3>
//             <p>
//               It is well known that HIV/AIDS epidemic represented the most
//               serious public health problem in India. It is estimated that more
//               than 5 million Indians are infected with the virus. The prevalence
//               of infection in all parts of the country highlights the spread
//               from urban to rural areas and from high risk to general
//               population. Delhi being an immigrating capital state faces
//               tremendous vulnerability. Delhi State AIDS Control Society (DSACS)
//               has been implementing NationalAIDS control program since 1992. In
//               the recent times, DSACS has implemented National AIDS Control
//               program–Phase III (NACP-III) under a five-year project
//               implementation plan (2005-2009). Targeted Intervention is one of
//               the core strategies for preventionof HIV in India under NACP-III.
//             </p>
//             <p>
//               The basic purpose of targeted Intervention program is to reduce
//               the rate of transmission among the most vulnerable and
//               marginalized sections of population such as commercial sex workers
//               (CSWs), men having sex with men (MSMs), truckers, street children,
//               migrant labor, intravenous drug users (IDUs) etc., who are highly
//               vulnerable to the transmission of HIV by virtue of their high risk
//               behavior and socio-economic conditions. This program was
//               implemented by DSACS through NGOs. AICURD being one such partner
//               NGO was entrusted with the implementation of targeted Intervention
//               program among migrant labourers. The project was last sanctioned
//               by DSACS in June 2008. The area selected for implementation of the
//               programme is Samaipur Badli in northwest Delhi.
//             </p>
//             <p>
//               A preliminary survey of Samaipur-Badli indicated that it was
//               8|Page a typical example of uncontrolled urbanization. The
//               population of Samaipur-Badli predominantly consists of laborers
//               who have migrated to Delhi in search of employment from other
//               states. The area is characterized by garbage; filth, smoke and
//               filthy water in open drains and stagnant pools that overwhelm
//               anyone visiting the area. These conditions have ultimately led to
//               a serious health hazard for the people. The programwas launched in
//               six clusters of Samaipur-Badli. In the initial stage the people in
//               the target area did not show much enthusiasm in the program on
//               control of HIV/AIDS. In fact, like most other communities, the
//               people considered the visits of AICURD functionaries as an
//               unwanted intrusion. Later with the repeated and persistent efforts
//               of AICURD through counseling, group discussions etc. the
//               community, by and large, accepted AICURD’s agenda on HIV/AIDS and
//               started extending cooperation in their endeavors.
//             </p>
//             <h3>
//               <strong className="text-gray-800 text-xl">
//                 RNTCP-DOT Centre, Delhi
//               </strong>
//             </h3>
//             <p>
//               AICURD was running five DOT centers in Samaipur Badli and
//               Bhalasawa as part of Revised National TB Control Program (RNTCP)
//               of Govt. of India and the Govt. of NCT Delhi. Unde this program,
//               five very poor clusters were identifiedwhich had tremendous
//               vulnerability for TB and other related pulmonary infection.
//             </p>
//             <p>
//               The areas were in and around northwest Delhi covering five major
//               clusters of the region. It may be indicated that the areas for TB
//               and HIV intervention were more or less similar simply because a
//               large percentage of HIV+ patients are prone to suffer from TB
//               infection due to breakdown in the overall immunity system of their
//               physiology. DOT providers were trained service providers in terms
//               of TB anti bacterial medicines. DOT centers were usually in the
//               midst of the community so that it could be easier for the poor and
//               malnourished people to conveniently come for their treatment. A
//               large number of poor people were benefited in this service
//               delivery of DOT. Qualitatively and quantitatively, AICURD had
//               invested a concerted effort in ensuring a much-desired service for
//               a needy section of society.
//             </p>
//             <p>
//               <strong className="text-orange-500 text-lg">
//                 Project on Participatory Waste Management in Bhalaswa, Delhi
//                 Under Yamuna Action Plan
//               </strong>
//             </p>
//             <p>
//               The Yamuna, as on today is an ailing river. Yet it is sacred to
//               all of us. The Yamuna is being polluted by raw sewage, fecal
//               matter, industrial effluents, dumping of solid waste and open
//               defecation, dumping of unburnt/half-burnt dead bodies and animal
//               carcasses, dhobi ghats, cattle wallowing,bathing and religious
//               offerings. It is for this reason that it had been considered
//               necessary to make every citizen in Delhi and every visitor to the
//               city to know as to how they pollute the Yamuna and how can they
//               help in bringing it back to its natural state. With this
//               realization ‘Public Participation and Public Awareness’ programme
//               was included as one of the nine components in the Yamuna Action
//               Plan (YAP). The YAP was funded by a loan from the Japan Bank of
//               International Co-operation (JBIC) to the National River
//               Conservation Directorate (NRCD), Government of India. The
//               implementation of the YAP in Delhi had been assigned to the
//               Municipal Corporation of Delhi (MCD).
//             </p>
//             <p>
//               The MCD entrusted the implementation of the above component of YAP
//               to the Asian Centre for Organization Research and Development
//               (ACORD). As the apex organization for implementation of the
//               component, ACORD was to work with three partner NGOs namely the
//               All India Centre for Urban and Rural Development (AICURD), the
//               Tata Energy Research Institute (TERI) and the Joint Assistance
//               Centre (JAC). The duration of the project was one year.
//             </p>
//             <ul className="list-disc pl-6 space-y-4 text-justify">
//               <strong className="text-orange-500 text-lg">
//                 Objectives of Yamuna Action Plans
//               </strong>
//               <li>
//                 Create public awareness and educate citizens of Delhi on the
//                 importance ofYamuna as Delhi’s lifeline, its current status and
//                 major sources of its pollution.
//               </li>
//               <li>
//                 Sensitize the citizens of Delhi on the relationship between some
//                 of the practices, their role in pollution of Yamuna and its
//                 impact on 10|Page their health.
//               </li>
//               <li>
//                 Influence people’s perceptions, attitudes and practices with
//                 respect to ‘Yamuna Cleaning’
//               </li>
//               <li>
//                 Promote wider usage of Community Toilet Complexes (CTCs) and
//                 educate the users on effective usage and maintenance of CTCs.
//               </li>
//               <li>
//                 Build the capacity of the Operation andMaintenance (O& M)
//                 agencies to maintain the CTCs with community participation
//               </li>
//               <li>
//                 Create public awareness about river pollution abatement measures
//                 taken by the Government
//               </li>
//             </ul>
//             <p className="list-disc pl-6 space-y-4 text-justify">
//               <strong className="text-orange-500 text-lg">
//                 Overall Results of YAP
//               </strong>
//               <p>
//                 It was expected that as a result of measures taken under Yamuna
//                 Action Plan, particularly People’s Participation and People’s
//                 Awareness, Delhi’s citizens would become more aware of the
//                 problem of pollution of Yamuna and the role they can play to
//                 save the river. It would bring about favorable changes in the
//                 practices prevalent among people; reduce pollution of Yamuna,
//                 and promote conservation of its waste. There would be increased
//                 and effective use of CTCs and these would be maintained better
//                 with the involvement of local communities. As a result, a
//                 sustainable and replicable model of participatory waste
//                 management would be developed.
//               </p>
//             </p>
//             <p className="list-disc pl-6 space-y-4 text-justify">
//               <strong className="text-orange-500 text-lg">
//                 Role of AICURD in YAP
//               </strong>
//               <p>
//                 As one of the partner NGOs in the implementation of People’s
//                 Participation and People’s Awareness component of YAP in Delhi,
//                 AICURD had been assigned the responsibility of developing a
//                 Pilot Scale Model on Participatory Waste Management in Bhalaswa
//                 Resettlement Colony, which could later be replicated in other
//                 parts of the city. The overall objective was to set up a
//                 community based non-municipal model of waste management.
//               </p>
//             </p>
//             <ul className="list-disc pl-6 space-y-4 text-justify">
//               <strong className="text-orange-500 text-lg">
//                 Major Achievements of the Pilot Project:-
//               </strong>
//               <p>
//                 The following are the major achievements of the Pilot project in
//                 the area of waste management since its initiation in December’
//                 2001:
//               </p>
//               <li>
//                 Completed a Baseline Survey of Bhalaswa Resettlement colony and
//                 compilation of pre-project data.
//               </li>
//               <li>
//                 Conducted community level programs, which included group
//                 meetings and awareness programs for children in the community.
//               </li>
//               <li>
//                 Organized an exposure of selected community representatives and
//                 concerned functionaries in the Project at J.J. Resettlement
//                 Cluster in Sector 26 of Rohini, Delhi that was being operated by
//                 NGO “Samarth”.
//               </li>
//               <li>
//                 Conducted a techno-economic feasibility study for technical
//                 interventionin waste management suited to Bhalaswa Resettlement
//                 Colony.
//               </li>
//               <li>
//                 Formed three Self Help Groups of women and conducted three
//                 training programs on thrift and credit.
//               </li>
//               <li>
//                 Introduced an improved Waste Collection System in Bhalaswa
//                 Resettlement Colony by selecting 10 workers from the community
//                 and providing requisiteorientation to them and procuring and
//                 making available necessary equipment such aswheel barrows,
//                 litter bins, cycle carts etc. to them.
//               </li>
//               <li>
//                 Completed a Baseline Survey of Bhalaswa Resettlement colony and
//                 compilation of pre-project data.
//               </li>
//               <li>
//                 Introduced a recycling system for (a) waste paper to manufacture
//                 hand-made paper and(b) waste polythene bags for manufacturing
//                 poly-cotton blended yarn and fabrication of sheets which can be
//                 used for making mats,bags etc.
//               </li>
//               <li>
//                 Setting up of a Recycling Facility Centre at Basti Vikas Kendra
//                 of MCD located in Bhalaswa Resettlement Colony.
//               </li>
//               <li>
//                 Training of members of Self Help Groups in Recycling of Waste
//                 Paper and Polythene bags harnessing appliances and equipments
//                 installed at Basti Vikas Kendra, Bhalaswa, Delhi.
//               </li>
//               <p>
//                 The work relating to collection, segregation and recycling of
//                 waste material continued during the year 2004-2005. Three
//                 12|Page SHGs that came up in the year 2002-2003 continued to
//                 function satisfactorily. The recycling units could not take up
//                 on commercial lines due to lack of the requisite infrastructure,
//                 several of the problems experienced in the implementation of the
//                 progammes due to delay in release of funds allocated for the
//                 project.
//               </p>
//             </ul>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Profile;

import React from "react";
import SEO from "../components/Seo";

// Full data extracted from Mile Stones.docx with only title + paragraphs
const mileStonesData = [
  {
    title: "Socio – Economic Survey",
    paragraphs: [
      "None can ignore the genuine desire of the Government to uplift the SC/ST people and the role played by its efforts in changing the mode of thinking and attitudes of these two segments of the population. Thus, the educational policies of the Government, provision of reservation in jobs, policies in the fields of agriculture, cooperation, communication, industrialization, social services, etc. have brought the members of the Scheduled Caste and Scheduled Tribe communities closer to the main stream of national life. Tribal markets have been linked up with urban markets providing greater economic opportunities to the tribals and SCs creating a commercial attitude in them, as a result, the concept of saving is gaining acceptance, and there is a definite shift in the consumption pattern of these two communities from need based to consumer durable goods. Yet, all said and done, the efforts so far have not helped in solving, in any significant measure, the problems of poverty, malnutrition and exploitation faced by the tribal as well as the Scheduled Castes.",
      "Keeping all these considerations in view, the Government of India initiated special schemes for the development of the areas inhabited by these two communities to supplement the benefits accruing from general programmes of development in different fields. These can be grouped broadly under four heads (a) communications (b) education and culture (c) development of tribal economy and (d) health, housing and water supply. AICURD was awarded the task of conducting mid-term survey to assess the impact of those schemes on these two communities in relation to Mehboob Nagar, Dumka, Prulia, Jalpiguri - four districts spreading over three states, being sponsored by the Union Ministry of Welfare.",
    ],
  },
  {
    title: "Health",
    paragraphs: [
      "In the area of health and Reproductive Child Health (RCH), AICURD has organized awareness camps focusing on subjects like Malaria and RCH. AICURD has also conducted programs on Targeted Intervention (TI) for Migrant Workers in Slums in Delhi to control and prevent HIV/AIDS, together with Generation of Scientific Awareness among Children & Adolescents in the Schools of Delhi, and on TB control Programme in and around the city of Delhi.",
    ],
  },
  {
    title: "RNTCP- DOT Centre, Delhi",
    paragraphs: [
      "AICURD was running five DOT centers in Samaipur- Badli and Bhalasawa as part of Revised National TB Control Program (RNTCP) of Govt. of India and the Govt. of NCT Delhi. Under this programme, five very poor clusters were identified which had tremendous vulnerability for TB and other related pulmonary infection. The areas were in and around northwest Delhi covering five major clusters of the region.",
    ],
  },
  {
    title: "Yamuna Action Plan",
    paragraphs: [
      "‘Public Participation and Public Awareness’ programme was included as one of the nine components in the Yamuna Action Plan (YAP). The YAP was funded by a loan from the Japan Bank of International Co-operation (JBIC) to the National River Conservation Directorate (NRCD), Government of India. The implementation of the YAP in Delhi had been assigned to the Municipal Corporation of Delhi (MCD).",
      "The MCD entrusted the implementation of the above component of YAP to the Asian Centre for Organization Research and Development (ACORD). As the apex organization for implementation of the component, ACORD was to work with three partner NGOs namely the All India Centre for Urban and Rural Development (AICURD), the Tata Energy Research Institute (TERI) and the Joint Assistance Centre (JAC). The duration of the project was one year.",
      "As one of the partner NGOs in the implementation of People’s Participation and People’s Awareness component of YAP in Delhi, AICURD had been assigned the responsibility of developing a Pilot Scale Model in a Resettlement Colony, which could later be replicated in other parts of the city. The overall objective was to set up a community based non municipal model of waste management which was successfully accomplished.",
    ],
  },
  {
    title: "UNDP – GOI Project on Solid Waste Management",
    paragraphs: [
      "AICURD in the year 2005 was also provided with a program on solid waste management under GOI-UNDP's National Strategy for Urban Poor in Dakshinpuri, a poor cluster in the southern part of Delhi. This project was basically to target the urban poor, mitigate their problem of waste management and related sanitation and an overall improvement in their socio- economic condition. AICURD had been able to inculcate the feeling of cleanliness and neatness among the people of this area. Right from the children to the youth and adults, every body was able to realize the need for having and maintaining a clean and hazard free environment in order to ensure a healthy life.",
      'AICURD has also been able to collaborate with CCM- AIIMS for the "Health seeking behavior survey" of Rag pickers in Dakshinpuri. AICURD also tried to introduce a micro-level vermin composting in the site. 30 rag pickers were imparted training on composting. AICURD organized two days workshop on vermin composting and RTI in Dakshinpuri.',
    ],
  },
  {
    title: "Environ Conservation",
    paragraphs: [
      "AICURD Uttarakhand, organized event to celebrate Harela Festival at Liti village of Bageshwar district and planted medicinal and fruit plant on barren lands. AICURD has in-house workforce meant for community mobilization for creating awareness on healthy environment, environment conservation and plantation. The plantation drives are strategically planned so that they inspire various strata of the society.",
    ],
  },
  {
    title: "Skill Development",
    paragraphs: [
      "AICURD has acquired vast experience in promoting handicrafts. Earlier it had harnessed NORAD scheme funded by the Department of Women and Child Development, Government of India, to promote local skills in the field of manufacturing Diversified Jute Products providing assured income to approximately 7000 women. It was felt that though women in rural areas of Jalpaiguri in West Bengal possess skills in making several useful articles out of bamboo, cane, jute, straw etc. that are available in plenty in Jalpaiguri district, these resources have not been properly harnessed due to difficulties faced by them in procurement of raw materials in time and at a reasonable price and then marketing the end products.",
      "AICURD, therefore, decided to launch a project for promotion of handicrafts in Jalpaiguri District by making arrangements for supply of raw materials, technological inputs, training of artisans, marketing support etc. with assistance available under Baba Sahib Ambedkar Hastshilpa Vikas Yojana (AHVY), run by the Ministry of Textiles, Government of India. The main objective is to ensure that handicrafts emerge as the alternative rural economic activity paving way for the people of Jalpaiguri District to avail of opportunities towards gainful work through self-employment.",
    ],
  },
  {
    title: "JAN SHIKSHAN SANSTHAN (JSS), JALPAIGURI, WEST BENGAL",
    paragraphs: [
      "Jan Shikshan Sansthan is a vocational training institute under Directorate of Adult Education, sponsored by the Ministry of Human Resource Development, Govt. of India. The Jan Shikshan Sansthan was established in 2000 at Jalpaiguri in West Bengal for promoting quality of human life, human settlements and physical and social environments. The activities of JSS has been expanded in taking up vocational & skill development programmes for illiterate, semiliterate people of the backward communities in both urban & rural areas of the district to make themselves self dependent.",
      "The participants are trained every year in different trades like repair of agro-based machineries including power tillers, pump sets, manufacture of fancy products from jute, fur, etc. garments-making, batik-printing, embroidery & making of Sal leaf plate, etc.",
    ],
  },
  {
    title: "Gender Resource Centre",
    paragraphs: [
      "Gender Resource Centre or Stree Shakti was an attempt of the Government of N.C.T. of Delhi to empower women, especially those belonging to the economically weaker section of the society. It was an integrated capacity building project through ‘Bhagidari’ with NGOs to strengthen the ability of women to participate equally in the mainstream of society. Health, literacy and income generation significantly impact the process of empowerment of women and therefore were prioritized in this project. AICURD was one of the NGOs which was administering this project in Samaypur, Badli.",
    ],
  },
  {
    title: "Implementation of SGSY",
    paragraphs: [
      "Jalpaiguri District Unit of AICURD in West Bengal had taken the responsibility of promoting SGSY in the district particularly in Jalpaiguri Sadar Block. AICURD has identified six volunteers who were actively engaged in the task of promoting the scheme, forming SHGs, helping them in attaining viability and monitoring progress in their work. AICURD had succeeded in forming around 541 SHGs in mainly four Gram Panchayats viz. Kharia Berubari G.P, Khagrabari-2 G.P., in Maynaguri Block, Mandalghat G.P. and Boalmari Nandanpur G.P of Jalpaiguri Sadar Block, Bank accounts of all the old SHGs have been opened.",
      "Evaluation of these groups have been done by the concerned evaluators of AICURD and duly supervised by Field Officers out of a total of 541 SHGs 305 SHGs have been graded.",
    ],
  },
  {
    title: "District Poverty Initiatives Project in Rajasthan",
    paragraphs: [
      "District Poverty Initiatives Project (DPIP) was an innovative scheme implemented by Rural Development Department of Government of Rajasthan that received assistance from International Development Association (IDA), World Bank. The long-term goal of the project was to reduce poverty in selected Districts, which are among the poorest in the State. The developmental objective of the project was to improve the living standards of specific groups of the rural poor by organizing them, building their capacities and empowering them to increase their access to infrastructure, services and resources that would address their poverty and social and economic needs.",
      "The approach of DPIP to poverty reduction was based on enhancement of institutional capacity for participatory planning and extension of poverty reducing interventions. At the field level, the project was implemented by the Department of Rural Development through NGOs having experience in rural development and community mobilization. In view of its commitment to and experience in holistic social and economic development, AICURD had been assigned with the responsibility for implementation of the project in Sujangarh Tehsil of district Churu in Rajasthan. As a lead agency AICURD was responsible for organizing all activities, which were considered critical to the success of the project.",
    ],
  },
  {
    title: "Articoll – The Cultural Wing",
    paragraphs: [
      "‘Articoll’ is like a magic potion for us. It has put life into all of us - its members in ways each of us needed most. It unites us and keeps us together, fills us with confidence to stand tall in front of the world and do our best in attempting to entertain, awaken and inspire. It fuels imagination, puts life into fiction and original stories. It helps us connect better, think with more empathy, reach out where we are needed. It makes us conscious of what’s happening around us, think of society as a whole and move on from ‘me’ to ‘we’. It is not associated with any political thought but the importance of necessary and productive ‘thinking’ is a driving force and the need to trigger productive ‘thought’ wherever required and possible is one of our constant endeavours.",
      "‘Articoll’ is an artistic branch of the mother tree All India Centre for Urban and Rural Development. It is a theatre group that aspires to bring in positive change with theatre as a source of healing, growth and development and mostly consists of students who study at the free computer training centre at AICURD.",
      "However, it is open to anyone who shares our love for theatre and wants to join the family. Many eminent theatre practitioners are attached to the group and carry out learning-based as well as production-oriented workshops for the group members and enthusiasts.",
    ],
  },
  {
    title: "National Integration and Communal Harmony",
    paragraphs: [
      "The year 1991 was a land mark for AICURD in its chequared history of growth as an NGO of national level. For quite sometime, AICURD had been reflecting on the need for taking up a suitable plan of work in order to involve itself wholeheartedly to play its role effectively in the national effort of combating the forces of secessionism and preserving and strengthening integration of the civil society of the country. Hence AICURD designed work plan for promoting secularism and national integration through social action by organizing and conducting national integration and communal harmony camps with the participation of young energetic and dynamic persons who could be the ‘Change Agents’ for confronting the disruptionist and divisive forces playing havoc with the nation's security and holding back the pace of socio-economic progress of the country.",
      "The participants in the camp would also be effective in creating awareness among common folks of the entirety of the issue in their immediate environment, which may ultimately help in arousing a spirit of brotherhood, concern for each other and a realization of the need to maintain peace, tranquility as well as to work hard for achieving these.",
      "A comprehensive Project Proposal was therefore prepared for holding five camps of 10-days duration each, along with its mode of operation, curriculum and budget and provisions required by the Department of Youth Affairs and Sports of the Union Ministry of Human Resource Development on the pattern of its scheme of support for activities on National Integration and Communal Harmony. The proposal was sanctioned and funds for organising the camps were released to AICURD. Accordingly five camps were held in Karnal, (Haryana), Ujjain (M.P), Hyderabad (A.P), Jammu and Kashmir and Sultanpur (U.P).",
    ],
  },
];

export default function MileStonesPage() {
  return (
    <>
      <SEO
        title="AICURD – Profile of AICURD"
        description="Profile of AICURD, leading initiatives in rural development, health, education, and women empowerment since 1985."
        keywords="AICURD, All India Centre for Urban and Rural Development, NGO Leadership, Rural Development Leader, Social Services, Community Development, NGO Profile, Women Empowerment, Health Awareness, Poverty Alleviation, Social Entrepreneur, SC ST Welfare, Tribal Welfare, Social Services NGO"
        author="MR PRINCE GUPTA"
        url="https://aicurd.org/profile"
        image="https://aicurd.org/images/profile-cover.jpg"
      />
      <div className="prose lg:prose-xl mx-auto p-6 poppins-regular bg-white min-h-screen">
        <h1 className="text-3xl sm:text-5xl md:text-5xl font-bold anton-regular text-orange-500 tracking-wider uppercase text-center">
          Mile Stones
        </h1>
        {mileStonesData.map((section, idx) => (
          <section key={idx} className="mb-8">
            <h2 className="text-xl font-semibold mb-2">{section.title}</h2>
            {section.paragraphs.map((p, i) => (
              <p key={i} className="mb-3 leading-relaxed text-justify">
                {p}
              </p>
            ))}
          </section>
        ))}
      </div>

      <div className="w-4/5 mx-auto mb-5">
        <div className="overflow-x-auto">
          <table className="w-full border border-gray-300 rounded-lg shadow-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="text-left p-3 font-semibold w-1/3 border-b border-gray-300">
                  Details
                </th>
                <th className="text-left p-3 font-semibold border-b border-gray-300">
                  Information
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="hover:bg-gray-50">
                <td className="p-3 border-b border-gray-200 font-medium">
                  Year of Establishment
                </td>
                <td className="p-3 border-b border-gray-200">1985</td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="p-3 border-b border-gray-200 font-medium">
                  Organization Registration – Type & No.
                </td>
                <td className="p-3 border-b border-gray-200">
                  Registered under Societies Registration Act of 1860;
                  Registration No.: S/15843
                </td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="p-3 border-b border-gray-200 font-medium">
                  Organization PAN Card No.
                </td>
                <td className="p-3 border-b border-gray-200">AAATA3799C</td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="p-3 border-b border-gray-200 font-medium">
                  Approval Under Section 80G & 12A
                </td>
                <td className="p-3 border-b border-gray-200">Enclosed</td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="p-3 border-b border-gray-200 font-medium">
                  CSR Registration Certificate (MCA)
                </td>
                <td className="p-3 border-b border-gray-200">Enclosed</td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="p-3 border-b border-gray-200 font-medium">
                  NGO DARPAN Registration No.
                </td>
                <td className="p-3 border-b border-gray-200">
                  DL/2009/0006449
                </td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="p-3 border-b border-gray-200 font-medium">
                  Organization Contact Address
                </td>
                <td className="p-3 border-b border-gray-200">
                  16, Bhai Veer Singh Marg, Gole Market, New Delhi 110001
                </td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="p-3 border-b border-gray-200 font-medium">
                  Contact Person
                </td>
                <td className="p-3 border-b border-gray-200">
                  Ms. Janani Ray, General Secretary, AICURD
                </td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="p-3 border-b border-gray-200 font-medium">
                  Email
                </td>
                <td className="p-3 border-b border-gray-200">
                  aicurd@yahoo.com
                </td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="p-3 font-medium">Contact</td>
                <td className="p-3">9717524902</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
